import React from 'react';
import "./theme/_main.scss"
import FadeInSection from "../../customizations/components/theme/Animations/FadeInSection"

const View = (props) => {
    const { data, isEditMode } = props;

    if (!data) {
        return <div>missing data</div>;
    }

    return (
        data?.elems?.map((kontakt, index) => (
            <FadeInSection key={index}>
                <article className="kontakt-kachel" aria-labelledby={`kontakt-${index}-name`}>
                    {kontakt.stadt && <p className='city'>{kontakt.stadt}</p>}
                    <div className="name-title-row">
                        {kontakt.name && <h4>{kontakt.name}</h4>}
                        {kontakt.titel && <p>{kontakt.titel}</p>}
                    </div>
                    {kontakt.funktion && <p>{kontakt.funktion}</p>}
                    {kontakt.telefon && <p>Tel: {kontakt.telefon}</p>}
                    {kontakt.mail && <a href={`mailto:${kontakt.mail}`}>{"E-Mail"}</a>}
                </article>
            </FadeInSection>
        ))
    )
};


export default View;
